import photo1 from '../assets/photos/photo1.png';
import photo6 from '../assets/photos/photo6.png';
import photo4 from '../assets/photos/photo4.png';


export interface Service {
  icon: string;
  label: string;
  image: string; // Agregamos una propiedad para la imagen
}

export const allServices: Service[] = [
  {
    icon: "⛽",
    label: "Oil, Brake and Tire Change",
    image: photo4,
  },
  {
    icon: "🛠️",
    label: "Maintenance and Diagnostic Service",
    image: photo6,
  },
  {
    icon: "🏆",
    label: "More than 2 years of experience",
    image: photo1,
  }
];

const [service1, service2, service3] = allServices;
export const initialTabs = [service1, service2, service3];
